import axios from "axios";
export async function getAnonSupportedLanguages() {
    const response = await axios.get('/api/workflow/anon/languages');
    return response.data;
}
